import { asyncApi } from "@/services/apiService";

const _baseEndpoint = `${process.env.VUE_APP_BASE_API}/api/job`;

export default {
  search: async (filter, onBeginCallback, onFinallyCallback) => {
    return asyncApi.get(
      `${_baseEndpoint}/available${filter}`,
      onBeginCallback,
      onFinallyCallback
    );
  },
  getSubscribers: async (reservationId, onBeginCallback, onFinallyCallback) => {
    return asyncApi.get(
      `${_baseEndpoint}/subscriber/${reservationId}`,
      onBeginCallback,
      onFinallyCallback
    );
  },
  getJobDetails: async (reservationId, onBeginCallback, onFinallyCallback) => {
    return asyncApi.get(
      `${_baseEndpoint}/${reservationId}`,
      onBeginCallback,
      onFinallyCallback
    );
  },
  getListSubscriberProvider: async (
    reservationId,
    onBeginCallback,
    onFinallyCallback
  ) => {
    return asyncApi.get(
      `${_baseEndpoint}/${reservationId}/subscriber/providers`,
      onBeginCallback,
      onFinallyCallback
    );
  },
  dispatchJob: async (
    payload,
    onBeginCallback,
    onFinallyCallback,
    onErrorCallback
  ) => {
    return asyncApi.post(
      `${_baseEndpoint}/accept`,
      payload,
      onBeginCallback,
      onFinallyCallback,
      onErrorCallback
    );
  },
  reassignPreferredProvider: async (
    reservationId,
    payload,
    onBeginCallback,
    onFinallyCallback
  ) => {
    return asyncApi.put(
      `${_baseEndpoint}/${reservationId}/preffered-provider/reassign`,
      payload,
      onBeginCallback,
      onFinallyCallback
    );
  },
  reassignProvider: async (
    reservationId,
    payload,
    onBeginCallback,
    onFinallyCallback,
    onErrorCallback
  ) => {
    return asyncApi.put(
      `${_baseEndpoint}/${reservationId}/provider/reassign`,
      payload,
      onBeginCallback,
      onFinallyCallback,
      onErrorCallback
    );
  }
};



// WEBPACK FOOTER //
// ./src/services/job/availableJobService.js